export async function copy(text) {
    try {
        await navigator.clipboard.writeText(text);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        const { copy: legacyCopy } = await import('./legacy-copy.js');
        legacyCopy(text);
    }
}
